<div *ngIf="workerMail" (click)="preventClickEvent($event)">
  <!-- s3にデータがある場合 -->
  <!-- 生メール -->
  <ng-container *ngIf="workerMail.rawdata_url">
    <a class="btn btn-dark float-left border-0" href="#" container="body"
      (click)="downloadMailFile()" (click)="createActionLog('eml')"><i class="fa fa-download"></i>
    </a>
  </ng-container>
</div>

<!-- 案件メール -->
<div *ngIf="projectMail" (click)="preventClickEvent($event)">
  <!-- s3にデータがある場合 -->
  <ng-container *ngIf="projectMail.rawdata_url">
    <a class="btn btn-dark float-left border-0" href="#" container="body"
      (click)="downloadMailFile()" (click)="createActionLog('eml')"><i class="fa fa-download"></i>
    </a>
  </ng-container>
</div>
